/**
 * Advisor-portal experience rules (#1513 — go-live blocker).
 *
 * Referral commissions must never be offered to legal professionals: paying
 * lawyers for client referrals implicates bar fee-splitting rules (e.g.,
 * FL Bar 4-7.22), and a "Referrals & Earnings" page inside an attorney's
 * portal is a compliance risk for the buying firm. Paralegals and mediators
 * operate under the same firm/bar umbrella and are excluded too.
 */

/** Profession types (advisor_profiles.profession_type) barred from the referral program. */
export const LEGAL_PROFESSION_TYPES = ['attorney', 'paralegal', 'mediator'] as const;

/**
 * Whether this advisor may see the referral/commission program.
 * Fails closed: unknown or missing profession → no referral surfaces.
 */
export function hasReferralAccess(professionType: string | null | undefined): boolean {
  if (!professionType) return false;
  return !(LEGAL_PROFESSION_TYPES as readonly string[]).includes(professionType);
}
